// extracted by mini-css-extract-plugin
export var statItem = "_lp-1";
export var statsRow = "_lp-0";